<div class="container-fluid p-3">

    <div class="d-flex gap-1">

        <mat-form-field appearance="outline" >
            <mat-label>Enter a date range</mat-label>
            <mat-date-range-input  [rangePicker]="picker">
                <input matStartDate [(ngModel)]="start" placeholder="Start date">
                <input matEndDate [(ngModel)]="end" placeholder="End date">
            </mat-date-range-input>
            <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>

            <!--            <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">Invalid start date</mat-error>-->
            <!--            <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Invalid end date</mat-error>-->

        </mat-form-field>&nbsp;
        <mat-form-field appearance="outline">
            <mat-label >Centre Name</mat-label>
            <mat-select  aria-label="Default select example" [formControl]="SelectCentre" (selectionChange)="fetchByCenter($event)">
                <mat-option  value="All">All Centres</mat-option>
                <mat-option *ngFor="let c of (centres$ | async)" [value]="c.centreCode">{{c.centreName}}</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field  appearance="outline" >
            <mat-label  >Attendance</mat-label>
            <mat-select [(value)]="mAttendance" >
                <mat-option  value="All">All</mat-option>
                <mat-option  value="Present">Present</mat-option>
                <mat-option  value="Absent">Absent</mat-option>

            </mat-select>
        </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Highlight</mat-label>
        <mat-select [(ngModel)]="mHighlight">
          <mat-option value="All">All</mat-option>
          <mat-option value="Highlight">Highlight</mat-option>
        </mat-select>
      </mat-form-field>

    </div>

    <div class="d-flex gap-1">

        <mat-form-field  appearance="outline" >
            <mat-label  >Session Type</mat-label>
            <mat-select [(value)]="mSession" >
                <mat-option  value="All">All</mat-option>

                <mat-option *ngFor="let t of sessionTypes"  [value]="t">{{t}}</mat-option>

            </mat-select>
        </mat-form-field>

        <mat-form-field  appearance="outline" >
            <mat-label  >Teacher</mat-label>
            <mat-select [(value)]="mTeacher" >
                <mat-option  value="All">All</mat-option>

                <mat-option *ngFor="let t of teachers$|async"  [value]="t.userName">{{t.userName}}</mat-option>

            </mat-select>
        </mat-form-field>

        <mat-form-field  appearance="outline" >
            <mat-label  >Volunteer</mat-label>
            <mat-select [(value)]="mVolunteer" >
                <mat-option  value="All">All</mat-option>

                <mat-option *ngFor="let t of volunteers$|async"  [value]="t">{{t}}</mat-option>

            </mat-select>
        </mat-form-field>
      <!-- Min Age -->
      <mat-form-field appearance="outline">
        <mat-label>Min Age</mat-label>
        <mat-select [(ngModel)]="minAge" (selectionChange)="validateAgeRange()">
          <mat-option [value]="null">All</mat-option>
          <mat-option *ngFor="let age of ageList" [value]="age">
            {{ age }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Max Age -->
      <mat-form-field appearance="outline">
        <mat-label>Max Age</mat-label>
        <mat-select [(ngModel)]="maxAge" (selectionChange)="validateAgeRange()">
          <mat-option [value]="null">All</mat-option>
          <mat-option *ngFor="let age of ageList" [value]="age">
            {{ age }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Error Message -->
      <div *ngIf="ageError" class="text-danger mt-1">
        Min Age should be less than or equal to Max Age
      </div>
        <button mat-mini-fab (click)="search()" color="accent"><mat-icon>search</mat-icon></button>
        <button mat-mini-fab (click)="clearAll()" color="accent"><mat-icon>clear</mat-icon></button>

    </div>

    <section class="card">
      <div class="ngxTableHeader">
        <ul class="header-buttons-left ms-0 mb-0">
          <li class="dropdown">
            <h2>Education Individual Sessions</h2>
          </li>
          <li class="dropdown m-l-20">
            <label for="search-input"><i class="material-icons search-icon">search</i></label>
            <input placeholder="Search" id="search-input" type="text" class="browser-default search-field"
                   (keyup)='applyFilter($event)' aria-label="Search box" #input>
          </li>
        </ul>
        <ul class="header-buttons mr-2">

          <li class="me-2">
            <button permission="Individual Session" [permissionTypes]="[PermissionType.ALL, PermissionType.ADD]" mat-mini-fab color="primary" (click)="OpenIndividualEducationComponent()">
              <mat-icon class="col-white" >add</mat-icon>
            </button>
          </li>



          <li>
            <button
              mat-mini-fab color="accent"
              (click)="downloadExcel()">
              <mat-icon>download</mat-icon>
            </button>
          </li>
          <li>
            <button mat-mini-fab color="primary" [matMenuTriggerFor]="columnsMenu" matTooltip="Show / Hide Columns">
              <mat-icon>view_column</mat-icon>
            </button>
            <mat-menu #columnsMenu="matMenu">
              <div class="p-2" (click)="$event.stopPropagation()">
                <div *ngFor="let col of toggleableColumns" class="d-flex align-items-center">
                  <mat-checkbox [checked]="isColumnVisible(col.colId!)"
                                (change)="toggleColumnVisibility(col.colId!, $event.checked)">
                    {{col.headerName}}
                  </mat-checkbox>
                </div>
                <div class="mt-2">
                  <button mat-stroked-button color="warn" (click)="resetColumns()">Reset Columns</button>
                </div>
              </div>
            </mat-menu>
          </li>
        </ul>
      </div>
      <mat-progress-bar *ngIf="isLoading" mode="indeterminate">Please wait Data is loading... </mat-progress-bar>

      <ag-grid-angular
        class="ag-theme-material education-individual-grid"
        style="width: 100%; height: 650px;"
        [rowData]="rowData"
        [columnDefs]="colDefs"
        [defaultColDef]="defaultColDef"
        [context]="context"
        [quickFilterText]="quickFilterText"
        [headerHeight]="38"
        [rowHeight]="40"
        [enableBrowserTooltips]="true"
        [animateRows]="true"
        [pagination]="true"
        [paginationPageSize]="25"
        [paginationPageSizeSelector]="[25,50,100,200,250,500,1000]"
        (gridReady)="onGridReady($event)"
        (columnMoved)="persistColumnState()"
        (columnVisible)="persistColumnState()"
        (columnResized)="onColumnResized($event)">
      </ag-grid-angular>

    </section>
</div>
